module.exports = __webpack_public_path__ + "img/o2o03.50e18600.png";